module.exports = __webpack_public_path__ + "img/status-change.d3e8cbaa.png";